import { useI18n } from '@/lib/i18n';
import { Link } from 'react-router-dom';
import { useCart } from '@/lib/cart';
import { ShoppingBag } from 'lucide-react';
import { toast } from 'sonner';

interface ArtworkCardProps {
  id: string;
  title: string;
  titleAr?: string | null;
  price: number;
  imageUrl?: string | null;
  category: string;
}

const ArtworkCard = ({ id, title, titleAr, price, imageUrl, category }: ArtworkCardProps) => {
  const { t, lang } = useI18n();
  const { addItem } = useCart();
  const displayTitle = lang === 'ar' && titleAr ? titleAr : title;

  return (
    <div className="group relative">
      <Link to={`/artwork/${id}`} className="block">
        <div className="relative overflow-hidden rounded-xl glass-panel group-hover:shadow-glow transition-all duration-500 border-0">
          <div className="aspect-square overflow-hidden">
            <img
              src={imageUrl || '/placeholder.svg'}
              alt={displayTitle}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
          </div>
          <div className="p-3">
            <p className="text-[10px] text-primary font-medium uppercase tracking-wider mb-1">{category}</p>
            <h3 className="font-display text-sm font-semibold text-card-foreground line-clamp-1">{displayTitle}</h3>
            <div className="flex items-center justify-between mt-2">
              <span className="text-sm font-bold text-primary">{t('currency')}{price}</span>
              <span className="text-xs text-muted-foreground group-hover:text-primary transition-colors">
                {t('viewDetails')} →
              </span>
            </div>
          </div>
        </div>
      </Link>
      <button
        onClick={(e) => {
          e.preventDefault();
          addItem({ id, title, title_ar: titleAr || null, price, image_url: imageUrl || null });
          toast.success(lang === 'ar' ? 'تمت الإضافة للسلة' : 'Added to cart');
        }}
        className="absolute top-2 right-2 h-8 w-8 rounded-full bg-card/80 backdrop-blur-sm border border-border/30 flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-card transition-all opacity-0 group-hover:opacity-100"
      >
        <ShoppingBag className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default ArtworkCard;
